export default "__VITE_ASSET__BbAuNKMz__"